
export class AnimatedBorder {
  #options;
  #keyframes;
  #$elem;
  #$border;
  #pulses = [];
  #animations = [];
  #observer;
  #size;

  constructor(duration = 5000, pulses = 2) {
    this.#options = {
      duration: duration,
      pulses: pulses
    };
  }

  attach(elem) {
    const $elem = elem instanceof jQuery ? elem : $(elem);

    if ($elem.length == 0) {
      return;
    }

    this.#$elem = $elem;
    this.#$elem.addClass("anim-border");

    this.#addMarkup();
    this.#getKeyframes();
    this.#animatePulses();
    this.#handleResize();
  }

  remove() {
    if (this.#$border == null) {
      return;
    }

    this.#$elem.removeClass("anim-border");
    this.#observer.disconnect();

    this.#pulses.forEach($p => {
      $p.remove();
    })
    this.#$border.remove();

    this.#pulses = [];
    this.#$border = null;
  }

  #getKeyframes() {
    this.#size = {
      width: this.#$elem.outerWidth(),
      height: this.#$elem.outerHeight()
    }

    const leftBorder = parseInt(this.#$elem.css("border-left-width"));
    const rightBorder = parseInt(this.#$elem.css("border-right-width"));
    const topBorder = parseInt(this.#$elem.css("border-top-width"));
    const bottomBorder = parseInt(this.#$elem.css("border-bottom-width"));

    const w = this.#size.width - leftBorder - rightBorder;
    const h = this.#size.height - topBorder - bottomBorder;
    const pathTotal = (w + h) * 2;
    const wRatio = w / pathTotal;
    const hRatio = h / pathTotal;

    this.#keyframes = [
      { transform: "translate(-5px, -5px)", offset: 0 },
      { transform: `translate(${w}px, -5px)`, offset: wRatio },
      { transform: `translate(${w}px, ${h}px)`, offset: wRatio + hRatio },
      { transform: `translate(-5px, ${h}px)`, offset: wRatio + hRatio + wRatio },
      { transform: "translate(-5px, -5px)", offset: 1 }
    ];
  }

  #animatePulses() {
    const numPulses = this.#pulses.length;
    const delayEach = this.#options.duration / numPulses;

    this.#pulses.forEach(($p, index) => {
      const timing = {
        duration: this.#options.duration,
        iterations: Infinity,
        // Negative delay causes the animation to
        // jump straight to this point.
        delay: -(index * delayEach),
      }

      const anim = $p[0].animate(this.#keyframes, timing)
      this.#animations.push(anim);
    });
  }

  #handleResize() {
    this.#observer = new ResizeObserver((entries) => {
      const $entry = $(entries[0].target);
      if (this.#size.width != $entry.outerWidth() || this.#size.height != $entry.outerHeight()) {
        this.remove();
        this.attach(this.#$elem);
      }
    });

    this.#observer.observe(this.#$elem[0]);
  }

  play() {
    this.#pulses;

    this.#pulses.forEach($p => {
      $p.css({ display: "unset" });
    });

    this.#animations.forEach(anim => {
      anim.play();
    })
  }

  pause() {
    this.#pulses.forEach($p => {
      $p.css({ display: "none" });
    });

    this.#animations.forEach(anim => {
      anim.pause();
    });
  }

  #addMarkup() {
    const $pulse = $("<div class='pulse'></div>");
    $pulse.css({
      position: "absolute",
      top: "0px",
      left: "0px",
      height: "5px",
      width: "5px",
      background: "var(--bs-info)",
      "border-radius": "50%",
      "box-shadow": "0 0 8px 4px var(--bs-info)",
      "z-index": 1
    });

    this.#$border = $("<div></div>");
    this.#$border.css({
      position: "absolute",
      inset: "0px",
      width: "100%",
      height: "100%",
      /* color-mix() mixes two colours but I'm mixing the info colour with transparent to just make it 25% opacity */
      "box-shadow": "0 0 0 5px color-mix(in srgb-linear, var(--bs-info) 25%, transparent)",
      "border-radius": this.#$elem.css("border-radius"),
      "z-index": -1
    });

    this.#$elem.css({
      "z-index": 0,
    });

    this.#$elem.append(this.#$border);

    for (var i = 0; i < this.#options.pulses; i++) {
      const $p = $pulse.clone().appendTo(this.#$elem);
      this.#pulses.push($p);
    }
  }
}